import appFooter from '@/components/public/common/footer/';
import welcome from '@/components/welcome-popup/index';

export default {
  name: 'terms-of-condition',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome,
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {

  }
}
